import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import {
  PoDialogService,
  PoModule,
} from "@po-ui/ng-components";
import { PasswordService } from "./password.service";
import { LoginService } from "../login/login.service";
import { FormsModule } from "@angular/forms";

@Component({
  selector: "app-ordemcoleta",
  templateUrl: "./password.component.html",
  styleUrls: ["./password.component.css"],
  standalone: false,
})
export class PasswordComponent implements OnInit {
  constructor(
    private passwordService:PasswordService,
    private router: Router,
    private poAlert: PoDialogService,
    private loginService: LoginService
  ) {}

  confirmNewPassword: string;
  currentPassword: string;
  errorPattern: string;
  help: string = 'Senha inicial = 12345678';
  newPassword: string;
  password: string;


  async setPassword() {
    if (this.confirmNewPassword === this.newPassword) {
      this.password = this.newPassword;
      this.help = `Actual password = ${this.password}`;
      
      await this.passwordService.alteraSenha(sessionStorage.getItem("codeuser"),this.newPassword,this.currentPassword).subscribe((goSenha) => {
       
        if(goSenha.status.match('sucesso!')){
          this.poAlert.alert({
            title: 'Alteração de senha',
            message: goSenha.status,
            ok: () => this.reset()
          });
        }else{
          this.poAlert.alert({
            title: 'Alteração de senha',
            message: goSenha.status,
            //ok: () => this.reset()
          });
        }
        
   /*
        this.currentPassword = undefined;
        this.newPassword = undefined;
        this.confirmNewPassword = undefined;
        */

      });
      
    } else {
      this.poAlert.alert({
        title: 'Erro',
        message: 'Sua (nova senha) é diferente de (confirme a nova senha)',
       // ok: () => this.reset()
      });
    }
  }

  reset() {
    this.newPassword = undefined;
    this.confirmNewPassword = undefined;
    this.loginService.fazerLogout();
  }

  sair(){
    this.router.navigate(["/"]);
  }

  ngOnInit() {}
}
